
import React, { Component } from 'react';
import { render } from 'react-dom';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';

import DialogContentCategoryItem from './DialogContentCategoryItem';

let resolve;

class DialogCreateCategoryItem extends Component {

    static create() {
        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);
        return render(<DialogCreateCategoryItem />, containerElement);
    }

    constructor(props) {
        super(props);
        this.state = {
            hidden: !props.show,
            color: '',
            title: ''
        };
    }

    checkValues() {
        let warnings = [];
        return (warnings.length === 0);
    }

    handleCancel = () => {
        this.setState({hidden: true});
        resolve(null);
    }

    handleConfirm = () => {
        if (this.checkValues()) {
            this.setState({hidden: true});
            resolve({
                color: this.state.color,
                title: this.state.title
            });
        }
    }

    handleChangeColor = (color) => {
        this.setState({
            color: color
        });
    }

    handleChangeTitle = (title) => {
        this.setState({
            title: title
        });
    }

    render () {
        return (
            <Dialog
                hidden={this.state.hidden}
                minWidth={500}
                onDismiss={this.handleCancel}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: "Vytvořit novou položku kategorie parcel"
                }}
                modalProps={{
                    isBlocking: false
                }}
                >
                    <DialogContentCategoryItem
                        onChangeColor={this.handleChangeColor}
                        onChangeTitle={this.handleChangeTitle}
                    />
                <DialogFooter>
                    <PrimaryButton onClick={this.handleConfirm} text="Vytvořit" />
                    <DefaultButton onClick={this.handleCancel} text="Zrušit" />
                </DialogFooter>
            </Dialog>
        );
    }

    show() {
        this.setState({
            hidden: false,
            color: '',
            title: ''
        });
        return new Promise((res) => {
            resolve = res;
        });
    }
}

export default DialogCreateCategoryItem.create();
